import { type FC, type ReactNode } from "react";
import { Icon } from "@root/shared/components/Icon";
import { fontSize } from "@root/shared/styles/sprinkles.css";
import * as styles from "./styles.css";

type Props = {
  href: string;
  gaAction: string;
  handleOnClose: () => void;
  children: ReactNode;
};

export const Presentation: FC<Props> = ({ href, children, gaAction, handleOnClose }) => (
  <span className={styles.outer} data-ga-action={gaAction}>
    <a
      href={href}
      className={styles.link}
      data-ga-action={gaAction}
      target="_blank"
      rel="noreferrer"
    >
      <span className={styles.targetBlankIconOuter}>
        <Icon name="target-blank" fontSize={fontSize["fs-16"]} />
      </span>
      {/* 親要素がflexboxなのでchildrenをspanでwrapする */}
      <span>{children}</span>
    </a>
    <span className={styles.line} />
    <button type="button" className={styles.closeButton} onClick={handleOnClose}>
      <Icon name="cross-thin" fontSize={fontSize["fs-12"]} />
    </button>
  </span>
);
